import { render, staticRenderFns } from "./SinMenu.vue?vue&type=template&id=7e1823e6&scoped=true&"
import script from "./SinMenu.vue?vue&type=script&lang=ts&"
export * from "./SinMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SinMenu.vue?vue&type=style&index=0&id=7e1823e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1823e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VContent})
